import type { FC, ReactNode } from 'react'

import { ArrowUpRight } from 'lucide-react'

import { FOOTER_QUOTE, MUSEUM_LINKS } from '@/constants/site'

const SiteFooter: FC = (): ReactNode => {
    return (
        <footer className='relative mt-auto overflow-hidden bg-ink'>
            <div aria-hidden='true' className='absolute inset-x-0 top-0 h-px bg-linear-to-r from-transparent via-gold/35 to-transparent' />
            <div aria-hidden='true' className='candle-glow pointer-events-none absolute left-1/2 top-0 h-72 w-[42rem] max-w-full -translate-x-1/2 -translate-y-1/2 animate-candle motion-reduce:animate-none' />

            <div className='relative mx-auto max-w-4xl px-6 py-20 text-center sm:py-24'>
                <figure>
                    <blockquote>
                        <p className='font-heading text-3xl italic leading-snug text-parchment sm:text-4xl'>
                            &ldquo;{FOOTER_QUOTE.text}&rdquo;
                        </p>
                    </blockquote>

                    <figcaption className='mt-5 text-[0.7rem] font-medium uppercase tracking-[0.32em] text-gold'>
                        &mdash; {FOOTER_QUOTE.author}
                    </figcaption>
                </figure>

                <nav aria-label='Rembrandt in museums' className='mt-14'>
                    <ul className='flex flex-wrap items-center justify-center gap-x-10 gap-y-4'>
                        {MUSEUM_LINKS.map((link) => (
                            <li key={link.href}>
                                <a
                                    href={link.href}
                                    target='_blank'
                                    rel='noopener noreferrer'
                                    className='group inline-flex items-center gap-1.5 rounded-sm py-1 text-sm tracking-wide text-parchment/70 transition-[color,text-shadow] duration-500 hover:text-gold hover:[text-shadow:0_0_18px_rgb(212_175_55/0.45)] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-4 focus-visible:ring-offset-ink'
                                >
                                    {link.label}

                                    <ArrowUpRight
                                        aria-hidden='true'
                                        className='size-4 opacity-60 transition-[opacity,translate] duration-500 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:opacity-100 motion-reduce:transition-none'
                                    />

                                    <span className='sr-only'>(opens in a new tab)</span>
                                </a>
                            </li>
                        ))}
                    </ul>
                </nav>

                <p className='mt-14 text-xs leading-relaxed text-parchment/55'>
                    Paintings reproduced courtesy of the National Gallery of Art, Washington.
                </p>
            </div>
        </footer>
    )
}

export default SiteFooter
